import { h, resolveComponent } from 'vue'
import DefaultLayout from '@/layouts/DefaultLayout'

export default [
    {
        path: '/login',
        name: 'Login',
        component: () => import('@/views/Login'),
        meta: {
            auth: false,
        },
    },
    {
        path: '/logout',
        name: 'Logout',
        redirect: '/login',
        component: () => import('@/views/Login'),
        meta: {
            auth: false,
        },
    },

    {
        path: '/attendance/report-pdf',
        name: 'AttendanceReportPdf',
        component: () => import('@/views/AttendanceReportPdf.vue'),
    },
    {
        path: '/invoice/:slug',
        name: 'pdf-invoicing',
        component: () => import('@/views/Invoicing/PdfInvoice.vue'),
    },
    {
        path: '/',
        name: 'Space',
        component: DefaultLayout,
        meta: {
            auth: true,
            roles: ['admin', 'worker'],
        },
        redirect: '/dashboard',
        children: [
            {
                path: '/dashboard',
                name: 'dashboard',
                component: () => import('@/views/Dashboard.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/candidates',
                name: 'candidates',
                component: () => import('@/views/Candidates.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/team',
                name: 'team',
                component: () => import('@/views/Team.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            // {
            //     path: '/profile',
            //     name: 'profile',
            //     component: () => import('@/views/Profile.vue'),
            //     meta: {
            //         auth: true,
            //         roles: ['admin', 'worker']
            //     }
            // },
            {
                path: '/profile/:name',
                name: 'profile',
                component: () => import('@/views/Profile.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/projects',
                name: 'projects',
                component: () => import('@/views/Projects.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'Sales manager'],
                },
            },
            {
                path: '/project/:id',
                name: 'projectPage',
                component: () => import('@/views/ProjectPage.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'Sales manager'],
                },
            },
            {
              path: '/invoicing',
              name: 'invoicing',
              component: () => import('@/views/Invoicing/Index.vue'),
              meta: {
                  auth: true,
                  roles: ['admin']
              }
          },
          // {
          //   path: '/invoicing/pdf/:id',
          //   name: 'pdf-invoicing',
          //   component: () => import('@/views/Invoicing/PdfInvoice.vue'),
          //   meta: {
          //       auth: true,
          //       roles: ['admin']
          //   }
          // },
          {
            path: '/invoicing/:id',
            name: 'single-invoicing',
            component: () => import('@/views/Invoicing/CreateInvoice.vue'),
            meta: {
                auth: true,
                roles: ['admin']
            }
          },
          {
            path: '/invoicing/create',
            name: 'invoicing-create',
            component: () => import('@/views/Invoicing/CreateInvoice.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/estimations',
            name: 'estimations',
            component: () => import('@/views/Estimations/Index.vue'),
            meta: {
              auth: true,
              roles: ['admin', 'worker', 'Sales manager', 'Project manager']
            }
          },
          {
            path: '/estimations/stacks',
            name: 'estimations-stacks',
            component: () => import('@/views/Estimations/Stacks.vue'),
            meta: {
              auth: true,
              roles: ['admin', 'worker', 'Sales manager', 'Project manager']
            }
          },
          {
            path: '/estimations/roles',
            name: 'estimations-roles',
            component: () => import('@/views/Estimations/Roles.vue'),
            meta: {
              auth: true,
              roles: ['admin', 'worker', 'Sales manager', 'Project manager']
            }
          },
          {
            path: '/estimations/portfolio',
            name: 'estimations-portfolio',
            component: () => import('@/views/Estimations/Portfolio.vue'),
            meta: {
              auth: true,
              roles: ['admin', 'worker', 'Sales manager', 'Project manager']
            }
          },
          {
            path: '/estimations/create',
            name: 'estimations-create',
            component: () => import('@/views/Estimations/EstimationEditor.vue'),
            meta: {
              auth: true,
              roles: ['admin', 'worker', 'Sales manager', 'Project manager']
            }
          },
          {
            path: '/estimations/:id',
            name: 'estimations-single',
            component: () => import('@/views/Estimations/EstimationEditor.vue'),
            meta: {
              auth: true,
              roles: ['admin', 'worker', 'Sales manager', 'Project manager']
            }
          },
          {
            path: '/legal-entity',
            name: 'legal entity',
            component: () => import('@/views/LegalEntity.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/legal-entity/account/edit/:id',
            name: 'edit account',
            component: () => import('@/views/EditAccount.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/add-account',
            name: 'add account',
            component: () => import('@/views/EditAccount.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/add-legal-entity',
            name: 'add legal entity',
            component: () => import('@/views/EditLegalEntity.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/legal-entity/view/:id',
            name: 'view legal entity',
            component: () => import('@/views/EditLegalEntity.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/legal-entity/edit/:id',
            name: 'edit legal entity',
            component: () => import('@/views/EditLegalEntity.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/legal-entity/account/:id',
            name: 'view account',
            component: () => import('@/views/EditAccount.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/types',
            name: 'types',
            component: () => import('@/views/ExpensesTypes.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          {
            path: '/leads-settings',
            name: 'leadsSettings',
            component: () => import('@/views/LeadsSettings.vue'),
            meta: {
              auth: true,
              roles: ['admin']
            }
          },
          
            {
                path: '/invoicing/:id',
                name: 'single-invoicing',
                component: () => import('@/views/Invoicing/CreateInvoice.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/invoicing/create',
                name: 'invoicing-create',
                component: () => import('@/views/Invoicing/CreateInvoice.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/legal-entity',
                name: 'legal entity',
                component: () => import('@/views/LegalEntity.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/legal-entity/account/edit/:id',
                name: 'edit account',
                component: () => import('@/views/EditAccount.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/add-account',
                name: 'add account',
                component: () => import('@/views/EditAccount.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/add-legal-entity',
                name: 'add legal entity',
                component: () => import('@/views/EditLegalEntity.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/legal-entity/view/:id',
                name: 'view legal entity',
                component: () => import('@/views/EditLegalEntity.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/legal-entity/edit/:id',
                name: 'edit legal entity',
                component: () => import('@/views/EditLegalEntity.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/legal-entity/account/:id',
                name: 'view account',
                component: () => import('@/views/EditAccount.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
             {
                path: '/hr/salary',
                name: 'salary',
                component: () => import('@/views/Salary.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/expenses',
                name: 'expenses',
                component: () => import('@/views/Expenses.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/income',
                name: 'income',
                component: () => import('@/views/Income.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/tasks',
                name: 'tasks',
                component: () => import('@/views/TasksListPage.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/tasks/:project',
                name: 'project',
                component: () => import('@/views/ProjectsPage.vue'),
                props: true,
                children: [
                    {
                        path: ':id',
                        name: 'taskDetail',
                        component: () => import('@/views/TaskPage.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker'],
                        },
                    },
                    {
                        path: 'info',
                        name: 'taskInfo',
                        component: () => import('@/views/ProjectInfo.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker'],
                        },
                    },
                ],
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: '/task/:tag/',
                name: 'singleTask',
                component: () => import('@/views/SingleTaskPage.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: '/tasks/:project/releases/',
                name: 'releases',
                component: () => import('@/views/Releases.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/tasks/:project/releases/:id',
                name: 'release',
                component: () => import('@/views/Release.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/calendar',
                name: 'calendar',
                component: () => import('@/views/VacationCalendar.vue'),
                meta: {
                    auth: false,
                },
            },

            {
                path: '/wasted-time',
                name: 'wasted-time',
                component: () => import('@/views/ProjectWasted.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: '/task-progress',
                name: 'task-progress',
                component: () => import('@/views/TaskProgress.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/task-reports',
                name: 'task-reports',
                component: () => import('@/views/TaskReports.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/vacations-details',
                name: 'vacations-details',
                component: () => import('@/views/VacationDetails.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/candidates-details',
                name: 'candidates-details',
                component: () => import('@/views/CandidatesDetails.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/wiki',
                name: 'wiki',
                component: () => import('@/views/Wiki.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },
            {
                path: '/wiki/:id',
                name: 'wikiArticle',
                component: () => import('@/views/WikiArticle.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: '/task',
                name: 'taskTagLayout',
                redirect: '/tasks',
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: 'task/:tag',
                name: 'taskByTag',
                component: () => import('@/views/Task.vue'),
            },
            {
                path: 'task/:taskTag/:subtaskTag:',
                name: 'SubTaskByTag',
                component: () => import('@/views/SubTask.vue'),
            },
            {
                path: 'task/:tag/add',
                name: 'AddSubTask',
                component: () => import('@/views/SubTaskLayout.vue'),
            },

            {
                path: '/attendance',
                name: 'attendance',
                component: () => import('@/views/Attendance.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: '/worktime-report',
                name: 'worktime report',
                component: () => import('@/views/WorktimeReport.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker'],
                },
            },

            {
                path: '/hr',
                name: 'hr',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr'],
                },
                redirect: '/hr/candidates',
                children: [
                    {
                        path: '/hr/candidates/:date',
                        name: 'candidates',
                        component: () =>
                            import('@/views/CandidateCalendar.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/candidate/:id',
                        name: 'candidate',
                        component: () => import('@/views/CandidatePage.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/birthday/:date',
                        name: 'birthday',
                        component: () => import('@/views/BirthdayCalendar.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/vacations/:date',
                        name: 'vacationsAndDaysOff',
                        component: () => import('@/views/VacationCalendar.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/task_manager',
                        name: 'taskManager',
                        component: () => import('@/views/TaskManager.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/jobcards',
                        name: 'jobCards',
                        component: () => import('@/views/JobCards.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'hr'],
                        },
                    },
                    {
                        path: '/hr/meetings/:date',
                        name: 'oneToOne',
                        component: () => import('@/views/OneToOneCalendar.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/meetings/:id/:user',
                        name: 'oneToOneReports',
                        component: () => import('@/views/OneToOneReport.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'worker', 'hr'],
                        },
                    },
                    {
                        path: '/hr/candidates/matching',
                        name: 'Matching',
                        component: () =>
                            import('@/views/CandidatesMatching.vue'),
                        meta: {
                            auth: false,
                        },
                    },
                    {
                        path: '/hr/onboarding-offboarding',
                        name: 'onboardingOffboarding',
                        component: () => import('@/views/OnboardingSettings.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'hr'],
                        },
                    },
                    {
                        path: '/hr/metrics',
                        name: 'hrMetrics',
                        component: () => import('@/views/HrMetrics.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'hr'],
                        },
                    },
						  {
                        path: '/hr/document-upload',
                        name: 'documentUpload',
                        component: () => import('@/views/Documents.vue'),
                        meta: {
                            auth: true,
                            roles: ['admin', 'hr'],
                        },
                    },
                ],
            },
            {
                path: '/projectteams',
                name: 'ProjectTeams',
                component: () => import('@/views/ProjectTeams.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
             {
                path: '/settings/general',
                name: 'GeneralSettings',
                component: () => import('@/views/GeneralSettings.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/settings/onboarding',
                name: 'OnboardingWorkflowBuilder',
                component: () => import('@/views/OnboardingWorkflowBuilder.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/hr/candidates/dashboard',
                name: 'candidatesDashboard',
                component: () => import('@/views/CandidatesDashboard.vue'),
                meta: {
                    auth: false,
                },
            },

            {
                path: '/users',
                name: 'users',
                component: () => import('@/views/Users.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/users/edit/',
                name: 'User',
                component: {
                    render() {
                        return h(resolveComponent('router-view'))
                    },
                },
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/users/edit/:id',
                name: 'Edit',
                component: () => import('@/views/EditUser.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/users/add/',
                name: 'user_add',
                component: () => import('@/views/NewUser.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/roles',
                name: 'role',
                component: () => import('@/views/Roles.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/positions',
                name: 'position',
                component: () => import('@/views/Positions.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
				{
                path: '/document-types',
                name: 'documentTypes',
                component: () => import('@/views/DocumentTypes.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'hr'],
                },
            },
            {
                path: '/selfassessment',
                name: 'selfAssessment',
                component: () => import('@/views/SelfAssessment.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/teamassessment',
                name: 'teamAssessment',
                component: () => import('@/views/TeamAssessment.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/teamassessment/:name',
                name: 'user',
                component: () => import('@/views/UserAssessment.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/userresults/:name',
                name: 'userresults',
                component: () => import('@/views/MateResults.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/review360settings',
                name: 'review360settings',
                component: () => import('@/views/Review360settings.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/review360settings',
                name: 'review360settings',
                component: () => import('@/views/Review360settings.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },
            {
                path: '/userresults',
                name: 'user_results',
                component: () => import('@/views/UserResults.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/teamresults',
                name: 'teams_results',
                component: () => import('@/views/ResultTeams.vue'),
                meta: {
                    auth: true,
                    roles: ['admin'],
                },
            },

            {
                path: '/notifications',
                name: 'notifications',
                component: () => import('@/views/Notifications.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr'],
                },
            },

            {
                path: '/leads',
                name: 'leads',
                component: () => import('@/views/Leads.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr', 'Sales manager'],
                },
            },
            {
                path: '/clients',
                name: 'clients',
                component: () => import('@/views/Clients.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr', 'Sales manager'],
                },
            },
            {
                path: '/crm/client-documents/:slug?',
                name: 'clientDocuments',
                component: () => import('@/views/ClientDocuments.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr', 'Sales manager'],
                },
            },

            {
                path: '/clients/edit/:id',
                name: 'client',
                component: () => import('@/views/EditClient.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr'],
                },
            },
            {
                path: '/clients/:id',
                name: 'client_view',
                component: () => import('@/views/EditClient.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr'],
                },
            },
            {
                path: '/clients/add/',
                name: 'new_client',
                component: () => import('@/views/NewClient.vue'),
                meta: {
                    auth: true,
                    roles: ['admin', 'worker', 'hr'],
                },
            },

            {
              path: '/inventory',
              name: 'inventory',
              component: () => import('@/views/Inventory.vue'),
              meta: {
                  auth: true,
                  roles: ['admin', 'hr', 'Project manager', 'Sales manager']
              }
            },
        ],
    },
    {
        path: '/:pathMatch(.*)*',
        name: 'Page404',
        component: () => import('@/views/Page404.vue'),
        meta: {
            roles: ['admin', 'worker'],
        },
    },
]
